import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { Button } from '../../components/ui/button.tsx';
import { logout } from '../../lib/api.ts';

export const Route = createFileRoute('/_authenticated/')({
  component: DashboardPage,
});

function DashboardPage() {
  // user + session come from _authenticated's beforeLoad return value.
  const { user, session } = Route.useRouteContext();
  const router = useRouter();
  const queryClient = useQueryClient();

  const logoutMutation = useMutation({
    mutationFn: logout,
    onSuccess: () => {
      // Invalidate cached /auth/me result + redirect to login. The next
      // navigation through _authenticated will re-fetch + bounce.
      queryClient.removeQueries({ queryKey: ['auth', 'me'] });
      router.navigate({ to: '/login' });
    },
  });

  const expiresInHours = Math.round((session.expires_at - Date.now()) / (1000 * 60 * 60));

  return (
    <div className="bg-background text-foreground flex min-h-screen items-center justify-center p-8">
      <div className="max-w-md space-y-6 text-center">
        <h1 className="text-3xl font-semibold tracking-tight">SEO Monitor</h1>
        <p className="text-muted-foreground">
          Signed in as <strong className="text-foreground">{user.email}</strong>{' '}
          <span className="text-xs">({user.role})</span>. Session expires in ~{expiresInHours}h.
        </p>
        <p className="text-muted-foreground">
          Dashboard placeholder — real domain/issue UI lands in later tasks.
        </p>
        <Button
          variant="outline"
          onClick={() => logoutMutation.mutate()}
          disabled={logoutMutation.isPending}
        >
          {logoutMutation.isPending ? 'Signing out…' : 'Sign out'}
        </Button>
      </div>
    </div>
  );
}
